import React from "react";
import "./index.less";
import { IconStarFill } from "@arco-design/web-react/icon";
function LoadingDom(props) {
  const { children, isLoading } = props;
  return (
    <div className="_root">
      <div className="mask" style={{ display: isLoading ? "block" : "none" }}>
        <div className="loading">
          <span>正</span>
          <span>在</span>
          <span>加</span>
          <span>载</span>
        </div>
      </div>
      {children}
    </div>
  );
}

export default LoadingDom;
